import type { CellStyle } from '@ag-grid-community/core'
import {
  ANCILLARY_EXTRA_LINES,
  AncillaryDateRange,
  AncillaryExtraLine,
  AncillaryLineCell,
  AncillaryReportRow,
} from '../api/ancillary-report.types'

export const PROBLEM_CELL_STYLE: CellStyle = {
  backgroundColor: '#FFC7CE',
  color: '#9C0006',
}

export function formatIsoDate(value: string | null): string {
  if (!value) return ''
  const [year, month, day] = value.slice(0, 10).split('-')
  return `${month}/${day}/${year}`
}

export function formatRange(range: AncillaryDateRange | null): string {
  if (!range) return 'None'
  return `${formatIsoDate(range.start)} – ${formatIsoDate(range.end) || 'no end'}`
}

/**
 * Red background for a line cell that put the person on this tab.
 */
export function visibleExtraLines(
  rows: readonly AncillaryReportRow[]
): AncillaryExtraLine[] {
  const present = new Set<string>()
  for (const row of rows) {
    for (const line of Object.keys(row.otherLines)) {
      present.add(line)
    }
  }
  return ANCILLARY_EXTRA_LINES.filter((line) => present.has(line))
}

export function lineCellStyle(
  cell: AncillaryLineCell | null | undefined
): CellStyle | null {
  return cell?.problem ? PROBLEM_CELL_STYLE : null
}
